export class GoogleRecaptchaHelper {
  public static scriptLoaded: boolean = false;
  /**
   * Appends recaptcha script to the DOM
   */
  public static async insertRecaptchaScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.scriptLoaded) {
        // already loaded
        resolve();
        return;
      }

      const googleReCaptchaScript = document.createElement("script");
      googleReCaptchaScript.onload = () => {
        this.scriptLoaded = true;
        resolve(); // recaptcha script loaded successfully
      };
      googleReCaptchaScript.onerror = () => {
        reject(new Error("Failed to load reCAPTCHA script"));
      };

      googleReCaptchaScript.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?render=" +
          import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY
      );

      document.head.appendChild(googleReCaptchaScript);
    });
  }

  /**
   * Removes the recaptcha script and cleans up DOM elements
   */
  public static async removeRecaptchaScript(): Promise<void> {
    return new Promise((resolve) => {
      if (!this.scriptLoaded) {
        // already removed
        resolve();
        return;
      }

      const googleReCaptchaScript = document.querySelector(
        "script[src='https://www.google.com/recaptcha/api.js?render=" +
          import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY +
          "']"
      );

      if (googleReCaptchaScript) {
        document.head.removeChild(googleReCaptchaScript);
        // Remove the recaptcha badge
        const badges = document.getElementsByClassName("grecaptcha-badge");
        while (badges.length > 0 && badges[0]) {
          badges[0].remove();
        }
        this.scriptLoaded = false;
      }

      resolve();
    });
  }

  public static getRecaptchaToken(action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha) {
        return reject("Recaptcha has not been initiated");
      }
      window.grecaptcha.ready(() => {
        Promise.resolve(
          window.grecaptcha.execute(
            import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY,
            { action }
          )
        )
          .then((googleReCaptchaToken: string) => {
            resolve(googleReCaptchaToken);
          })
          .catch((error: unknown) => {
            reject(error);
          });
      });
    });
  }
}
